import { Carousel as RRCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

const Carousel = RRCarousel
export default Carousel
